import currency from 'currency.js';
import { Numeric } from './typescript';

export const amountToUsd = (amount?: Numeric) => amount ? currency(amount).format() : null;

export const amountToKhr = (amount?: Numeric) =>
  amount ? currency(amount, { pattern: '# ៛', precision: 0 }).format() : null;

export const formatCurrency = (amount?: Numeric) => amountToUsd(amount) || '$0.00';

export const formatPercentage = (percent?: Numeric, precision = 1) => {
  if (percent === undefined || percent === null) return `0.${'0'.repeat(precision)}%`;
  return `${Number(percent).toFixed(precision)}%`;
};
